import { useEffect, useState } from 'react';

import * as dateFns from 'date-fns';
import { Stack } from '@mui/material';
import { dateRangeForTransactions } from 'src/utils/rollup';
import { useFinanceContext } from 'src/components/plaid/datasource';
import useDateRangePicker from './use-date-range-picker';
import InlineDateRangePicker from './rollup-period-picker';

// Date picker
export default function RollUpTools({ ...other }) {
  const { transactions, rollup, setRollup, dateRange, setDateRange } = useFinanceContext();
  const rangeInputPicker = useDateRangePicker(dateRange?.startDate, dateRange?.endDate);
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  useEffect(() => {
    if (!isInitialLoad) {
      if (
        rangeInputPicker?.startDate &&
        rangeInputPicker?.endDate &&
        rangeInputPicker?.endDate !== rangeInputPicker?.startDate
      ) {
        localStorage.setItem(
          'dateRange',
          JSON.stringify({
            startDate: rangeInputPicker?.startDate,
            endDate: rangeInputPicker?.endDate,
          })
        );
        // console.log('⏳ saved date range to local storage');
      }
    }
    setIsInitialLoad(false);
    setDateRange({ startDate: rangeInputPicker?.startDate, endDate: rangeInputPicker?.endDate });
  }, [rangeInputPicker.startDate, rangeInputPicker.endDate]);

  // Load date range from local storage on component mount
  useEffect(() => {
    const storedDateRange = JSON.parse(localStorage.getItem('dateRange'));
    // if there is a stored date range, set it
    if (storedDateRange?.startDate && storedDateRange?.endDate) {
      setDateRange({
        startDate: new Date(storedDateRange?.startDate),
        endDate: new Date(storedDateRange?.endDate),
      });
    } else {
      // If not found in local storage, set dateRange to the full transaction range
      const { start, end } = dateRangeForTransactions(transactions);
      const startDate = start || dateFns.startOfYear(new Date());
      const endDate = end || dateFns.endOfYear(new Date());

      setDateRange({ startDate, endDate });
      // Set a default date range if needed (e.g., 10 years by default)
      // setDateRange({ startDate: dateFns.subYears(new Date(), 10), endDate: new Date() });
    }
  }, [transactions]);

  return (
    <Stack
      direction={{ xs: 'column-reverse', sm: 'row' }}
      justifyContent="end"
      alignItems="center"
      sx={{ ...other?.sx, visibility: other?.hidden ? 'hidden' : 'visible', width: '100%' }}
    >
      <InlineDateRangePicker
        open={rangeInputPicker.open}
        startDate={rangeInputPicker.startDate || new Date()}
        endDate={rangeInputPicker.endDate || new Date()}
        onChangeStartDate={rangeInputPicker.onChangeStartDate}
        onChangeEndDate={rangeInputPicker.onChangeEndDate}
        onClose={rangeInputPicker.onClose}
        error={rangeInputPicker.error}
        rollup={rollup}
        setRollup={setRollup}
        sx={other?.sx}
      />
    </Stack>
  );
}
